// Styles
import '@mdi/font/css/materialdesignicons.css'
import '../styles/main.scss'

// Vuetify
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { pt } from 'vuetify/locale'

const vuetify = createVuetify({
  components,
  directives,
  locale: {
    locale: 'pt',
    fallback: 'en',
    messages: { pt },
  },
  theme:{
    defaultTheme: 'light',
    themes:{
      light:{
        dark: false,
        colors:{
          'text-neutral-primary': '#191C1C',
          'text-brand-primary': '#004F4F',
          'border-neutral-primary': "#E1E3E2",
          'primary-60': "#00A1A1",
          'primary-40': "#006A6A",
          'primary-35': "#005C5C",
          'neutral-100': "#FFF",
          'neutral-98': "#F8FAF9",
          'neutral-95': "#EFF1F0",
          'neutral-80': "#C4C7C6",
          'neutral-60': "#8E9191",
          'neutral-50':"#747877",
          'neutral-35': "#505353",
          'neutral-15': "#1E2727",
          'neutral-10': "#191C1C",
          'error-40': "#BA1A1A",
          'success-system':"#23BF6A",
          'alert-system-dark': "#FFB30F"
        }
      }
    }
  },
  aliases:{
    RbInput: components.VTextField,
    RbInputBase: components.VInput,
    RbSwitch: components.VSwitch,
    RbTextarea: components.VTextarea,
    RbAutocomplete: components.VAutocomplete,
    RbSelect: components.VSelect
  },
  defaults: {
    RbSwitch:{
      class: 'rb-switch d-flex align-center',
      color: 'primary-60',
      baseColor: 'neutral-35',
      hideDetails: true,
      inset: true
    },
    VBtn:{
      style: 'text-transform: none;font-family: Roboto; font-size: 14px; line-height: 20px; font-weight: 500; letter-spacing: 0;',
    },
    RbInputBase:{
      color: "primary-60",
      bgColor: "neutral-98",
      style:"font-family: Roboto; font-size: 16px; color: neutral-10",
      class:"rb-input",
    },
    RbInput:{
      color: "primary-60",
      bgColor: "neutral-98",
      style:"font-family: Roboto; font-size: 16px; color: neutral-10",
      class:"rb-input",
    },
    RbTextarea:{
      color: "primary-60",
      bgColor: "neutral-98",
      style:"font-family: Roboto; font-size: 16px; color: neutral-10",
      class:"rb-textarea",
    },
    RbAutocomplete:{
      color: "primary-60",
      bgColor: "neutral-98",
      style:"font-family: Roboto; font-size: 16px; color: neutral-10",
      class:"rb-autocomplete",
    },
    RbSelect:{
      color: "primary-60",
      bgColor: "neutral-98",
      style:"font-family: Roboto; font-size: 16px; color: neutral-10",
      class:"rb-select",
    },
    VCheckbox:{
      class: 'rb-checkbox'
    }
  }
})

export default vuetify